import BaseReducer from "../BaseReducer";
import AdidAction from "./adidAction";

export default class AdidReducer extends BaseReducer {
  initialState = {
    locations: [],
    adidInfo: [],
  };

  /* SET ANY PROPERTY TO store*/
  [AdidAction.UPDATE_ADID_STATE](state, action) {
    return {
      ...state,
      ...action.payload,
    }
  }

}
